import React, {useContext} from "react"
import Row from "@amzn/meridian/row";
import Alert from "@amzn/meridian/alert";
import {AlertContext} from "./context/AlertContext";

const AlertView = () => {
    const {alertViewModel, alertDispatch} = useContext(AlertContext)

    const removeNotification = () => {
        alertDispatch({type: 'REMOVE_NOTIFICATION'});
    }

    return (
        <div>
            {alertViewModel.alert.title ?
                <Row widths={["grid-8"]} spacingInset="large large none" alignmentHorizontal="center">
                    <Alert onClose={() => removeNotification()}
                           size="medium" type={alertViewModel.alert.type}>{alertViewModel.alert.title}</Alert>
                </Row>
                : null}
        </div>
    )
}

export default AlertView



// WEBPACK FOOTER //
// ./src/components/alert/AlertView.js